<template>
  <template v-for="(stack, k) of wizard.stacks">
    <pf-radio
      v-if="stack.os.includes(wizard.os)"
      :key="k"
      name="stack"
      :required="required"
      :value="k"
      :checked="modelValue === k"
      @change="emit('update:modelValue', k)"
    >
      <template #label>
        <span class="capitalized">{{ k }}</span>
        <wizard-price-tag
          v-if="modelValue !== k || wizard.stacks[k].codici.length === 1"
          :label="wizard.stacks[k].codici.length === 1 ? $t('Prezzo') : $t('A partire da')"
          :product="wizard.minPrice(wizard.stacks[k].codici)"
        />
      </template>

      <template #description>
        {{ stack.descrizione }}

        <pf-helper-text
          v-if="stack.minCpu > wizard.cpuCloudQt || stack.minRam > wizard.ramCloudQt || stack.minStorage > wizard.storageCloudQt"
          class="pf-v6-u-mt-sm"
        >
          <pf-helper-text-item v-if="stack.minCpu > wizard.cpuCloudQt">
            <template #icon>
              <info-icon />
            </template>
            {{
              $t('Il minimo numero di CPU necessarie per questo stack è {0}, selezionandolo la configurazione del server verrà modificata di conseguenza', [
                stack.minCpu,
              ])
            }}
          </pf-helper-text-item>
          <pf-helper-text-item v-if="stack.minRam > wizard.ramCloudQt">
            <template #icon>
              <info-icon />
            </template>
            {{
              $t('La RAM minima necessaria per questo stack è {0} GB, selezionandolo la configurazione del server verrà modificata di conseguenza', [
                stack.minRam,
              ])
            }}
          </pf-helper-text-item>
          <pf-helper-text-item v-if="stack.minStorage > wizard.storageCloudQt">
            <template #icon>
              <info-icon />
            </template>
            {{
              $t('Lo storage minimo necessario per questo stack è {0} GB, selezionandolo la configurazione del server verrà modificata di conseguenza', [
                stack.minStorage,
              ])
            }}
          </pf-helper-text-item>
        </pf-helper-text>
      </template>
    </pf-radio>

    <div v-if="modelValue === k && stack.codici.length > 1" class="stack-products">
      <wizard-question-prodotti v-model="wizard.codiceProdottoStack" :prodotti="stack.codici" name="codiceProdottoStack" required />
    </div>
  </template>
</template>

<style lang="scss" scoped>
.capitalized {
  text-transform: capitalize;
}

.stack-products {
  margin-block-start: var(--pf-t--global--spacer--sm);
  padding-inline-start: var(--pf-t--global--spacer--lg);
}

.pf-v6-c-radio {
  margin-block-start: var(--pf-t--global--spacer--md);

  .wizard-question-header + & {
    margin-block-start: 0;
  }
}
</style>

<script setup lang="ts">
import { useWizard, type OpzioniStack } from '@/wizard';
import WizardQuestionProdotti from '../questions/wizard-question-prodotti.vue';
import WizardPriceTag from '../wizard-price-tag.vue';
import InfoIcon from '@vue-patternfly/icons/info-icon';

defineOptions({
  inheritAttrs: false,
});

defineProps<{
  modelValue: OpzioniStack | null | undefined;
  required?: boolean;
}>();

const emit = defineEmits<{
  (name: 'update:modelValue', v: OpzioniStack | null): void;
}>();

const wizard = useWizard();
</script>
